export const firstComments = 100;
